module.exports = __webpack_public_path__ + "fonts/CRC55.8327bfff.woff";